'use client';

import { IconContext } from '@phosphor-icons/react';
import type { ReactNode } from 'react';

interface PhosphorProviderProps {
  children: ReactNode;
}

export default function PhosphorProvider({ children }: PhosphorProviderProps) {
  return (
    <IconContext.Provider value={{ weight: 'bold', size: 28 }}>
      {children}
    </IconContext.Provider>
  );
}
